import { ComponentType, lazy } from "react"

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const lazily = <T extends Record<string, any>>(loader: () => Promise<T>) =>
  new Proxy({} as unknown as T, {
    get: (_, moduleName: string) => {
      const LazyComponent = lazy(() =>
        loader().then((x) => {
          return {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            default: x[moduleName] as ComponentType<any>,
          }
        })
      )

      // Add `displayName` for React developer component tree
      if (LazyComponent) {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        ;(LazyComponent as ComponentType<any>).displayName = moduleName
      }

      return LazyComponent
    },
  })
